import React, { useEffect } from "react";
import { NavigationFromConfig } from "best-common-react";
import { RouteConstants } from "../../constants/RouteConstants";
import { useAuth } from "../../contexts/AuthContext";
import { withRouter } from "react-router-dom";
import env from "../../env";
import { AuthConstants } from "../../constants/AuthConstants";

const LineupCardNavigation = withRouter(({ history }) => {
  const {
    isAdmin,
    hasRole,
    state: { loggedIn, email },
    dispatch: authDispatch,
  } = useAuth();
  const shouldDisableLogoClick = hasRole(AuthConstants.ROLES.CUSTOM_CARD);

  // this should be a prop in the config, but we can add that when we rewrite the navigation
  useEffect(() => {
    if (!shouldDisableLogoClick) {
      return undefined;
    }

    const logoLink = document.querySelector("#lineup-card-navigation .navbar-brand");
    if (!logoLink) {
      return undefined;
    }

    const blockLogoNavigation = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };

    logoLink.style.cursor = "default";
    logoLink.addEventListener("click", blockLogoNavigation);

    return () => {
      logoLink.style.cursor = "";
      logoLink.removeEventListener("click", blockLogoNavigation);
    };
  }, [shouldDisableLogoClick]);

  const NavConfig = {
    env: env.appEnv,
    displayEnvIndicator: env.appEnv !== "prod",
    loggedIn: loggedIn,
    username: email,
    logo: null,
    logoText: "Lineup Cards",
    title: "",
    tabletSupport: false,
    vertical: false,
    usernameDropdownLinks: [
      {
        name: "Sign Out",
        to: "",
        onClick: () => {
          authDispatch({ type: "logout" });
        },
      },
    ],
    navigationLinks: [
      {
        name: "Games",
        to: RouteConstants.GAMES,
        visible: !hasRole(AuthConstants.ROLES.CUSTOM_CARD),
      },
      {
        name: "Logo Manager",
        to: RouteConstants.LOGO,
        visible: hasRole(AuthConstants.ROLES.ADMIN),
      },
      {
        name: "Custom Cards",
        to: RouteConstants.CUSTOM_CARDS,
        visible: isAdmin() || hasRole(AuthConstants.ROLES.CUSTOM_CARD) || hasRole(AuthConstants.ROLES.VIEW_ONLY),
      },
      {
        name: "Settings",
        to: RouteConstants.SETTINGS,
        visible: isAdmin(),
      },
    ],
  };

  return (
    <div id="lineup-card-navigation">
      <NavigationFromConfig config={NavConfig} />
    </div>
  );
});

export default LineupCardNavigation;
